import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { fetch } from '../../actions'
import { useFetchPostV2, useSavePost } from '../../components/Hooks/Conexao'
import { Drawer, Switch, Input, Radio, Button } from 'antd';
import Mensagens from '../../components/Mensagens';

function Parametros(props) {
    const [dados, listar, loading, setDados] = useFetchPostV2(props.fetch, '/cliente', { modelo: 'parametros', dados: { id: props.id } })
    const [selected, setSelected] = useState(null);
    const [selectedValue, setSelectedValue] = useState('');

    const [save, saving] = useSavePost(props.fetch, '/cliente/save', { modelo: 'parametros', dados: { id: props.id, idPar: selected ? selected.id : 0, valor: selectedValue } },
        () => {
            const list = [];
            dados.forEach(x => {
                if (x.id === selected.id) {
                    list.push({ ...x, valor: selectedValue });
                }
                else {
                    list.push({ ...x });
                }
            });

            setDados(list);
            setSelected(null); setSelectedValue('');
            Mensagens.showSucesso('Gravado com sucesso!');
        });

    useEffect(() => {
        listar()
    }, [])

    if (loading) {
        return <div>Carregando...</div>
    }

    return (
        <>

            {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
            <table className="tabela-padrao" style={{ marginTop: 10 }}>
                <tbody>
                    {(dados || []).map(x => {
                        return (
                            <tr key={x.id} style={{ cursor: 'pointer' }} onClick={() => { setSelected(x); setSelectedValue(x.valor); }} >
                                <td>{x.tag}</td>
                                <td>{x.nome}</td>
                                <td style={{ fontWeight: 'bold' }}>{x.valor}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>

            <Drawer
                style={{ zIndex: 2000 }}
                width={400}
                title={selected ? selected.nome : ''}
                placement='right'
                closable={true}
                onClose={() => { setSelected(null); setSelectedValue(''); }}
                visible={!(!selected)}
            >
                {selected && (
                    <>
                        <div style={{ marginBottom: 20 }}><Button type="primary" onClick={save} loading={saving}>Gravar</Button></div>
                        {selected.tipo === 'bool' && <Switch checked={selectedValue === 'SIM'} onChange={checked => setSelectedValue(checked ? 'SIM' : 'NÃO')} />}
                        {selected.tipo === 'string' && <Input value={selectedValue} onChange={e => setSelectedValue(e.target.value)} />}
                        {selected.tipo === 'combo' && (
                            <Radio.Group onChange={e => setSelectedValue(e.target.value)} value={selectedValue}>
                                {(selected.valoresPossiveis.split(';')).map((x, inx) => {
                                    return (<Radio key={inx} style={{ display: 'block', height: '30px', lineHeight: '30px' }} value={x}>
                                        {x}
                                    </Radio>)
                                })}
                            </Radio.Group>

                        )}
                    </>
                )}
            </Drawer>
        </>
    )
}
export default connect(null, { fetch })(Parametros);